var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnion = function SvgUnion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.88889 20C4.65314 20 4.42706 19.9064 4.26036 19.7397C4.09366 19.573 4 19.3469 4 19.1111V10.2222C4 9.98647 4.09366 9.76034 4.26036 9.59364C4.42706 9.42694 4.65314 9.33333 4.88889 9.33333H9.33333V4.88889C9.33333 4.65314 9.427 4.42701 9.5937 4.26031C9.76039 4.09361 9.98647 4 10.2222 4H19.1111C19.3469 4 19.5729 4.09361 19.7396 4.26031C19.9063 4.42701 20 4.65314 20 4.88889V13.7778C20 14.0135 19.9063 14.2397 19.7396 14.4064C19.5729 14.5731 19.3469 14.6667 19.1111 14.6667H14.6667V19.1111C14.6667 19.3469 14.573 19.573 14.4063 19.7397C14.2396 19.9064 14.0135 20 13.7778 20H4.88889Z"
  })));
};
export default SvgUnion;